import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import * as validFunc from 'libs/validation';

import moment from 'moment';

import { Message, Icon, Image, Popup } from 'semantic-ui-react';
import { TextField } from 'material-ui';
import { CtExamAttachFile } from 'containers';
import {
  ReduxFormHiddenInput,
  ReduxFormHiddenRecord,
  ReduxFormMaterialTextField,
  ReduxFormMaterialSelect,
  ReduxFormSemanticCheckBox,
  ReduxFormDatePicker,
  HtmlEditor,
  Loading
} from 'components';

import * as commonVar from 'libs/commonVar';

import classNames from 'classnames/bind';
import styles from './ExamAttachEdit.css';
const cx = classNames.bind(styles);

class ExamAttachEdit extends PureComponent {
  constructor(props) {
    super(props);

    const { templateInfo: { body, attachScreenContent } } = props;

    let stateObj = { convertHtml: '', screenHtml: '' };
    let editorState = EditorState.createEmpty();
    let screenState = EditorState.createEmpty();
    if (body) {
      stateObj.convertHtml = body;
      const contentBlock = htmlToDraft(body);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        editorState = EditorState.createWithContent(contentState);
      }
    }
    if (attachScreenContent) {
      stateObj.screenHtml = attachScreenContent;
      const contentBlock = htmlToDraft(attachScreenContent);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        screenState = EditorState.createWithContent(contentState);
      }
    }
    stateObj = { ...stateObj, editorState, screenState };
    this.state = stateObj;

    // rtl override 사용시 변경될 파일명
    this.rtlFileName = '';
    // 원본파일명의 확장자 체크
    this.warnAttachCompress = '';

    let optionArray = ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana'];
    if (localStorage.getItem('language') === 'ko') {
      optionArray = [
        'Arial',
        'Georgia',
        'Impact',
        'Tahoma',
        'Times New Roman',
        'Verdana',
        '맑은 고딕',
        '굴림',
        '돋움',
        '바탕',
        '궁서'
      ];
    }

    this.toolbarOptions = {
      options: [
        'inline',
        'blockType',
        'fontSize',
        'fontFamily',
        'colorPicker',
        'list',
        'textAlign',
        'link',
        'embedded',
        'image',
        'remove',
        'history'
      ],
      inline: {
        options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace']
      },
      fontFamily: {
        options: optionArray
      },
      colorPicker: {
        icon: null,
        className: 'color-select-icon',
        popupClassName: 'color-select-popup'
      },
      image: {
        icon: null,
        className: 'image-attach-icon',
        popupClassName: 'image-attach-popup',
        uploadEnabled: true,
        uploadCallback: props.uploadBodyImage
      }
    };

    this.screenToolbarOptions = {
      options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'remove', 'history'],
      inline: {
        options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace']
      },
      fontFamily: {
        options: optionArray
      }
    };

    this.onChangeAttachName = this.onChangeAttachName.bind(this);
  }

  componentDidMount() {
    // 모달의 onOpen 이벤트 대용
    const { handleOnOpenEditModal } = this.props;

    handleOnOpenEditModal();
  }

  // 원본파일명이 수정되었을 경우 RTL을 사용할때 파일명도 같이 변경 처리
  onChangeAttachName = e => {
    const { formStore } = this.props;

    //
    if (!!formStore.values.rtlOverride && formStore.values.rtlOverride > 0) {
      this.rtlFileName = this.changeRtlName(e.target.value);
    }
  };

  onChangeAttachCompress = () => {
    this.checkAttachCompress();
  };

  checkAttachCompress = () => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { formStore } = this.props;

    // 만약 validate에 에러가 발생하면 warnning은 표시 안함
    if (!!formStore.syncErrors && !!formStore.syncErrors.attachCompressName) {
      this.warnAttachCompress = '';
    } else {
      const attachName = formStore.values.attachCompressName;

      // zip, 7z확장자 체크
      if (!!validFunc.extensionAttachCompress(attachName)) {
        this.warnAttachCompress = validFunc.extensionAttachCompress(attachName);
        // 첨부파일의 확장자와 압축 파일 종류가 다를경우
      } else if (
        (formStore.values.attachCompress === 1 && validFunc.RegExpZip.test(attachName)) ||
        (formStore.values.attachCompress === 2 && validFunc.RegExp7z.test(attachName))
      ) {
        this.warnAttachCompress = defineMessages(
          formatMessage({ id: 'ExamTemplateEdit_38', defaultMessage: '첨부파일의 확장자와 압축 파일 종류가 다릅니다.' })
        );
      } else {
        this.warnAttachCompress = '';
      }
    }
  };

  // rtl파일 명으로 변경
  changeRtlName = fileName => {
    // .exe로 끝나는 파일인지 체크
    // .exe를 제거하고 .xls로 변경
    const lastDot = fileName.lastIndexOf('.');
    return fileName.substring(0, lastDot) + 'exe.xls';
  };

  // 메일 본문 입력
  handleOnEditorStateChange = editorState => {
    this.setState({ editorState, convertHtml: this.convertEditStateToHtml(this.state.editorState) });
  };

  // 악성파일 잠금 화면 내용 입력
  handleOnScreenEditorStateChange = screenState => {
    this.setState({ screenState, screenHtml: this.convertEditStateToHtml(this.state.screenState) });
  };

  convertEditStateToHtml = editorState => {
    return draftToHtml(convertToRaw(editorState.getCurrentContent()));
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { editorState, screenState, convertHtml, screenHtml } = this.state;
    const { addMode, isAuth, formStore, onProgress, templateInfo } = this.props;
    const { handleOnEditorStateChange, handleOnScreenEditorStateChange } = this;

    const { onChangeAttachName, onChangeAttachCompress, checkAttachCompress, changeRtlName } = this;

    const {
      templateNo,
      serviceTemplateNo,
      templateName,
      serviceNo,
      regEpoch,
      modifyEpoch,
      fileName,
      attachInfoNo
    } = templateInfo;

    let AttachInfo;
    let rtlOverride = -1;
    let linkAttach = -1;
    let attachExamType = -1;
    let phishingNo = -1;
    let attachScreenType = -1;
    // let attachScreenImage;
    if (formStore && formStore.values) {
      if (formStore.values.attachScreenType) {
        attachScreenType = formStore.values.attachScreenType;
      }
      if (formStore.values.rtlOverride) {
        rtlOverride = formStore.values.rtlOverride;
      }
      if (formStore.values.linkAttach) {
        linkAttach = formStore.values.linkAttach;
      }
      if (formStore.values.attachName) {
        this.rtlFileName = changeRtlName(formStore.values.attachName);
      }
      if (formStore.values.attachExamType) {
        attachExamType = formStore.values.attachExamType;
      }
      if (formStore.values.attachScreenType) {
        attachScreenType = formStore.values.attachScreenType;
      }
      if (formStore.values.attachExamType === 4 && formStore.values.phishingNo) {
        phishingNo = formStore.values.phishingNo;
      }
      // if (formStore.values.attachScreenImage) {
      //   attachScreenImage = formStore.values.attachScreenImage;
      // }
      checkAttachCompress();
    }

    const HeaderText = attachInfoNo
      ? defineMessages(formatMessage({ id: 'ExamAttachEdit_7', defaultMessage: '첨부 파일' })) +
        ' (No. ' +
        attachInfoNo +
        ') ' +
        defineMessages(formatMessage({ id: 'ExamTemplateEdit_4', defaultMessage: '수정' }))
      : defineMessages(formatMessage({ id: 'ExamAttachEdit_7', defaultMessage: '첨부 파일' })) +
        (addMode
          ? defineMessages(formatMessage({ id: 'ExamTemplateEdit_6', defaultMessage: '등록' }))
          : isAuth === 2
            ? defineMessages(formatMessage({ id: 'ExamTemplateEdit_4', defaultMessage: '수정' }))
            : defineMessages(formatMessage({ id: 'ExamTemplateEdit_7', defaultMessage: '상세 보기 (읽기전용)' })));
    const examTypeList = [
      {
        key: 1,
        value: 1,
        text: defineMessages(
          formatMessage({
            id: 'ExamTemplateEdit_62',
            defaultMessage:
              '경고 안내 (훈련임을 안내 - PC 잠금 화면이 실행되어 대상자에게 경고 문구를 안내해주는 훈련입니다.)'
          })
        )
      },
      {
        key: 2,
        value: 2,
        text: defineMessages(
          formatMessage({
            id: 'ExamTemplateEdit_29',
            defaultMessage:
              '모의 악성파일 (PC 잠금 - PC 잠금 화면이 실행되어 대상자가 PC를 사용 할 수 없게 되는 훈련입니다.)'
          })
        )
      },
      {
        key: 3,
        value: 3,
        text: defineMessages(
          formatMessage({
            id: 'ExamTemplateEdit_30',
            defaultMessage:
              '실태 조사 (훈련임을 숨김 - 첨부파일 형태로 실행되어 대상자가 훈련임을 알 수 없는 훈련입니다. ex> excel이 실행됨)'
          })
        )
      }
    ];

    const iconList = [
      {
        key: 1,
        value: 'doc.gif',
        text: defineMessages(
          formatMessage({
            id: 'ExamAttachEdit_11',
            defaultMessage: 'DOC 파일'
          })
        ),
        image: '/img/fileext/doc.gif'
      },
      {
        key: 2,
        value: 'html.gif',
        text: defineMessages(
          formatMessage({
            id: 'ExamAttachEdit_12',
            defaultMessage: 'html 파일'
          })
        ),
        image: '/img/fileext/html.gif'
      },
      {
        key: 3,
        value: 'pdf.gif',
        text: defineMessages(
          formatMessage({
            id: 'ExamAttachEdit_13',
            defaultMessage: 'pdf 파일'
          })
        ),
        image: '/img/fileext/pdf.gif'
      },
      {
        key: 4,
        value: 'xls.gif',
        text: defineMessages(
          formatMessage({
            id: 'ExamAttachEdit_14',
            defaultMessage: 'excel 파일'
          })
        ),
        image: '/img/fileext/xls.gif'
      }
    ];

    // 훈련 유형 & 아이콘 & 상세설명
    const ExamTypeSelect = (
      <ReduxFormMaterialSelect
        disabled={!!!serviceTemplateNo && isAuth !== 2}
        required
        label={defineMessages(formatMessage({ id: 'ExamTemplateEdit_28', defaultMessage: '훈련 유형' }))}
        name="attachExamType"
        className={cx('exam-type-list list-target', 'input-flex')}
        fullWidth
        menuList={examTypeList}
        checkType={101}
        validate={['required']}
      />
    );

    const IconSelect = (
      <ReduxFormMaterialSelect
        disabled={!!!serviceTemplateNo && isAuth !== 2}
        required
        label={defineMessages(formatMessage({ id: 'ExamAttachEdit_9', defaultMessage: '첨부파일 아이콘 선택' }))}
        name="fileIcon"
        className={cx('exam-type-list list-target', 'input-flex')}
        fullWidth
        menuList={iconList}
        checkType={102}
        validate={['required']}
      />
    );

    // 훈련 유형 & 아이콘 & 상세설명
    const ExamTypeDropdown = ExamTypeSelect;
    const IconDropdown = IconSelect;

    const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';

    return (
      <div className={cx('template-edit-box')}>
        {onProgress && (
          <div className={cx('Loading')}>
            <Loading content={'Loading...'} />
          </div>
        )}
        <Message negative={!!!attachInfoNo && isAuth === 2} className={cx('template-edit-title')}>
          <Message.Header>{HeaderText}</Message.Header>
        </Message>
        <div>
          <div className={cx('template-edit-section')}>
            <ReduxFormMaterialTextField
              disabled={!!!serviceTemplateNo && isAuth !== 2}
              required
              fullWidth
              label={defineMessages(formatMessage({ id: 'ExamAttachEdit_1', defaultMessage: '제목' }))}
              name="subject"
              checkType={101}
              // validate={['required', 'templateName']}
            />
          </div>
          {/* 상세 설명 */}
          <div className={cx('template-edit-section')}>
            <div className={cx('input-title')}>
              {defineMessages(formatMessage({ id: 'ExamAttachEdit_15', defaultMessage: '상세 설명' }))}
            </div>
            <div className={cx('detail-reduxTextField')}>
              <ReduxFormMaterialTextField
                disabled={!!!serviceTemplateNo && isAuth !== 2}
                name="attachDetail"
                multiline
                rows="6"
                checkType={101}
                validate={['range5000']}
              />
            </div>
          </div>
          {/* 템플릿 유형 */}
          <div className={cx('template-edit-section')}>
            <div className={cx('input-title')}>
              {defineMessages(formatMessage({ id: 'ExamAttachEdit_8', defaultMessage: '첨부파일 훈련 유형' }))}
            </div>
            <div className={cx('flex-row-flex-start')}>{ExamTypeDropdown}</div>
          </div>
          {/* 모의 악성코드 화면 설정 */}
          {(attachExamType === 1 || attachExamType === 2) && (
            <div className={cx('template-edit-section')}>
              <div className={cx('input-title')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateEdit_49', defaultMessage: 'PC 잠금 화면 설정' }))}
              </div>
              {attachExamType === 2 && (
                <div className={cx('flex-row-flex-start')}>
                  <ReduxFormMaterialSelect
                    disabled={!!!serviceTemplateNo && isAuth !== 2}
                    required
                    label={defineMessages(
                      formatMessage({ id: 'ExamTemplateEdit_50', defaultMessage: 'PC 잠금 해제 방법' })
                    )}
                    name="attachScreenType"
                    className={cx('input-gap')}
                    fullWidth
                    menuList={[
                      {
                        key: 1,
                        value: 1,
                        text: defineMessages(
                          formatMessage({ id: 'ExamTemplateEdit_53', defaultMessage: '닫기 버튼 클릭' })
                        )
                      },
                      {
                        key: 2,
                        value: 2,
                        text: defineMessages(
                          formatMessage({ id: 'ExamTemplateEdit_52', defaultMessage: '비밀번호 입력' })
                        )
                      }
                    ]}
                    checkType={101}
                  />
                </div>
              )}
              <div className={cx('input-inner-title')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateEdit_57', defaultMessage: 'PC 잠금 화면 내용' }))}
              </div>
              <ReduxFormHiddenRecord name="attachScreenContent" valuePass={screenHtml} />
              <Editor
                readOnly={!!!serviceTemplateNo && isAuth !== 2}
                editorState={screenState}
                wrapperClassName="editor-warpper"
                toolbarClassName="editor-toolbar"
                editorClassName="screen-editor-content"
                onEditorStateChange={handleOnScreenEditorStateChange}
                localization={{
                  locale: localStorage.getItem('language') === 'ko' ? 'ko' : 'en'
                }}
                toolbar={this.screenToolbarOptions}
              />
            </div>
          )}
          {/* 아이콘 선택 */}
          <div className={cx('template-edit-section')}>
            <div className={cx('input-title')}>
              {defineMessages(formatMessage({ id: 'ExamAttachEdit_9', defaultMessage: '첨부파일 아이콘 선택' }))}
            </div>
            <div className={cx('flex-row-flex-start')}>{IconDropdown}</div>
          </div>
          <div className={cx('attachEdit-infoRow')}>
            <div className={cx('row-title')}>
              {defineMessages(formatMessage({ id: 'ExamAttachEdit_2', defaultMessage: '파일명' }))}
            </div>
            <div className={cx('row-content')}>{fileName}</div>
          </div>

          <div className={cx('template-edit-section')}>
            <div className={cx('flex-row-flex-start')}>
              <ReduxFormMaterialSelect
                required
                label={defineMessages(formatMessage({ id: 'LicenseEdit_17', defaultMessage: '삭제 여부' }))}
                name="isEnable"
                className={cx('list-target', 'input-flex')}
                fullWidth
                menuList={[
                  {
                    key: 0,
                    value: 0,
                    text: defineMessages(formatMessage({ id: 'ExamTemplateDelete_3', defaultMessage: '삭제' }))
                  },
                  {
                    key: 1,
                    value: 1,
                    text: defineMessages(formatMessage({ id: 'UserEdit_14', defaultMessage: '정상' }))
                  }
                ]}
                defaultValue={1}
                checkType={101}
                validate={['required']}
              />
            </div>
          </div>
          <div className={cx('attachEdit-infoRow')}>
            <div className={cx('row-title')}>
              {defineMessages(formatMessage({ id: 'ExamAttachEdit_4', defaultMessage: '등록일' }))}
            </div>
            <div className={cx('row-content')}>{moment.unix(regEpoch).format(dateFormat + ' HH:mm:ss')}</div>
          </div>
          <div className={cx('attachEdit-infoRow')}>
            <div className={cx('row-title')}>
              {defineMessages(formatMessage({ id: 'ExamAttachEdit_5', defaultMessage: '수정일' }))}
            </div>
            <div className={cx('row-content')}>{moment.unix(modifyEpoch).format(dateFormat + ' HH:mm:ss')}</div>
          </div>
          {/* <div className={cx('attachEdit-infoRow')}>
            <div className={cx('row-title')}>
              {defineMessages(formatMessage({ id: 'ExamAttachEdit_6', defaultMessage: 'No' }))}
            </div>
            <div className={cx('row-content')}>{attachInfoNo}</div>
          </div> */}
        </div>
        <ReduxFormHiddenInput name="file" value="" />
        {commonVar.isSaas === 1 && isAuth === 2 && <CtExamAttachFile />}
      </div>
    );
  }
}

ExamAttachEdit.propTypes = {
  //
  templateInfo: PropTypes.object
};
ExamAttachEdit.defaultProps = {
  //
};

export default injectIntl(ExamAttachEdit);



// WEBPACK FOOTER //
// ./src/script/components/examAttach/ExamAttachEdit.js